"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _excluded = ["width", "height", "closeColor", "isOpen", "children", "fullWidth", "className", "customStyles"];

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var GlobalStyle = (0, _styledComponents.createGlobalStyle)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    body {\n        overflow: ", "\n    }\n"])), function (props) {
  return props.isPopupOpen ? 'hidden' : 'auto';
});

var PopupWrapper = _styledComponents["default"].div.withConfig({
  displayName: "defaultPopup__PopupWrapper",
  componentId: "sc-1nmwm0g-0"
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    width: 100vw;\n    height: 100vh;\n    position: fixed;\n    top: 0;\n    left: 0;\n    z-index: 1000;\n    background: rgba(37, 40, 56, 0.4);\n    overflow: hidden;\n    cursor: pointer;\n    ", ";\n"])), function (p) {
  var _p$customStyles$popup, _p$customStyles;

  return (_p$customStyles$popup = p === null || p === void 0 ? void 0 : (_p$customStyles = p.customStyles) === null || _p$customStyles === void 0 ? void 0 : _p$customStyles.popupWrapper) !== null && _p$customStyles$popup !== void 0 ? _p$customStyles$popup : '';
});

var Container = _styledComponents["default"].div.withConfig({
  displayName: "defaultPopup__Container",
  componentId: "sc-1nmwm0g-1"
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    display: flex;\n    width: 100%;\n    height: 100%;\n    overflow: auto;\n    justify-content: space-between;\n    align-items: center;\n    flex-direction: column;\n    ", ";\n"])), function (p) {
  var _p$customStyles$conta, _p$customStyles2;

  return (_p$customStyles$conta = p === null || p === void 0 ? void 0 : (_p$customStyles2 = p.customStyles) === null || _p$customStyles2 === void 0 ? void 0 : _p$customStyles2.container) !== null && _p$customStyles$conta !== void 0 ? _p$customStyles$conta : '';
});

var Popup = _styledComponents["default"].div.withConfig({
  displayName: "defaultPopup__Popup",
  componentId: "sc-1nmwm0g-2"
})(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    position: relative;\n    cursor: auto;\n    display: block;\n    min-height: 100px;\n    min-width: 200px;\n    border-radius: 4px;\n    width: ", ";\n    height: ", ";\n    max-width: ", ";\n    background:", ";\n    animation: slideInBottom 0.4s;\n    margin: auto;\n    overflow: ", ";\n    ", ";\n    @keyframes slideInBottom {\n        0% {\n          transform: translateY(-1000px);\n          opacity: 0;\n        }\n        100% {\n          transform: translateY(0);\n          opacity: 1;\n        }\n      }\n"])), function (props) {
  return props.width ? props.width : 'auto';
}, function (props) {
  return props.height ? props.height : 'auto';
}, function (props) {
  return props.fullWidth ? '100%' : '95%';
}, function (props) {
  return props.color ? props.color : '#fff';
}, function (props) {
  return props.fullWidth ? 'auto' : 'initial';
}, function (p) {
  var _p$customStyles$popup2, _p$customStyles3;

  return (_p$customStyles$popup2 = p === null || p === void 0 ? void 0 : (_p$customStyles3 = p.customStyles) === null || _p$customStyles3 === void 0 ? void 0 : _p$customStyles3.popup) !== null && _p$customStyles$popup2 !== void 0 ? _p$customStyles$popup2 : '';
});

var ClosePopup = _styledComponents["default"].div.withConfig({
  displayName: "defaultPopup__ClosePopup",
  componentId: "sc-1nmwm0g-3"
})(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    position: absolute;\n    width: 26px;\n    height: 26px;\n    background: 0 0;\n    transform: rotate(45deg);\n    transition: all .2s linear;\n    z-index: 10;\n    cursor: pointer;\n    top: 15px;\n    right: 15px;\n    &::before {\n        position: absolute;\n        content: '';\n        width: 2px;\n        height: 24px;\n        margin-top: -11px;\n        left: 50%;\n        top: 50%;\n        background: ", ";\n        transition: all .2s linear;\n    }\n    &::after {\n        position: absolute;\n        content: '';\n        width: 24px;\n        height: 2px;\n        margin-left: -11px;\n        left: 50%;\n        top: 50%;\n        background: ", ";\n        transition: all .2s linear;\n    }\n"])), function (props) {
  return props.color ? props.color : 'black';
}, function (props) {
  return props.color ? props.color : 'black';
});

var ID_POPUP_ROOT = 'popup-wrapper';

var DefaultPopup = /*#__PURE__*/function (_Component) {
  _inherits(DefaultPopup, _Component);

  var _super = _createSuper(DefaultPopup);

  function DefaultPopup() {
    var _this;

    _classCallCheck(this, DefaultPopup);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      popupRoot: null,
      popupArea: /*#__PURE__*/_react["default"].createRef(),
      // стейт для глобальных стилей
      popupOpen: false
    });

    _defineProperty(_assertThisInitialized(_this), "togglePopupOpen", function (popupOpen) {
      _this.setState({
        popupOpen: popupOpen
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setPopupRoot", function () {
      if (process.browser && !_this.state.popupRoot) {
        var popupRoot = document.getElementById(ID_POPUP_ROOT);

        if (!popupRoot) {
          popupRoot = document.createElement('div');
          popupRoot.setAttribute('id', ID_POPUP_ROOT);
          document.body.appendChild(popupRoot);
        }

        _this.setState({
          popupRoot: popupRoot
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "closePopupFromWrapper", function (event) {
      if (event.target == _this.state.popupArea.current) {
        _this.close();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "close", function () {
      _this.props.onClose();
    });

    return _this;
  }

  _createClass(DefaultPopup, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setPopupRoot();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var isOpen = this.props.isOpen;

      if (!prevProps.isOpen && isOpen) {
        this.togglePopupOpen(true);
      }

      if (prevProps.isOpen && !isOpen) {
        this.togglePopupOpen(false);
      }

      this.setPopupRoot();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          popupArea = _this$state.popupArea,
          popupRoot = _this$state.popupRoot,
          popupOpen = _this$state.popupOpen;

      if (popupRoot == null) {
        return null;
      }

      var _this$props = this.props,
          width = _this$props.width,
          height = _this$props.height,
          closeColor = _this$props.closeColor,
          isOpen = _this$props.isOpen,
          children = _this$props.children,
          fullWidth = _this$props.fullWidth,
          className = _this$props.className,
          customStyles = _this$props.customStyles,
          rest = _objectWithoutProperties(_this$props, _excluded);

      var popup = isOpen ? /*#__PURE__*/_react["default"].createElement(PopupWrapper, {
        customStyles: customStyles
      }, /*#__PURE__*/_react["default"].createElement(Container, {
        onClick: this.closePopupFromWrapper.bind(this),
        ref: popupArea,
        customStyles: customStyles
      }, /*#__PURE__*/_react["default"].createElement(Popup, _extends({
        width: width,
        height: height,
        fullWidth: fullWidth,
        className: className,
        customStyles: customStyles
      }, rest), /*#__PURE__*/_react["default"].createElement(ClosePopup, {
        color: closeColor,
        onClick: this.close
      }), children))) : null;

      if (popupRoot) {
        return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(GlobalStyle, {
          isPopupOpen: popupOpen
        }), /*#__PURE__*/_reactDom["default"].createPortal(popup, popupRoot));
      }

      return null;
    }
  }]);

  return DefaultPopup;
}(_react.Component);

exports["default"] = DefaultPopup;